function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m60.511 36.422-5.0661-18.227a24.853 24.853 0 0 0-48.205 1.2639l-3.9222 17.638a13.332 13.332 0 0 0 13.015 16.225h2.9703a13.332 13.332 0 0 0 26.13 0h2.2344a13.332 13.332 0 0 0 12.847-16.899zm-28.143 22.232a7.9991 7.9991 0 0 1-7.5085-5.3327h15.017a7.9991 7.9991 0 0 1-7.5085 5.3327zm21.667-13.825a7.9378 7.9378 0 0 1-6.3699 3.1596h-31.332a7.9991 7.9991 0 0 1-7.8071-9.7349l3.9196-17.641a19.52 19.52 0 0 1 37.862-0.99189l5.0661 18.227a7.9378 7.9378 0 0 1-1.3332 6.9805z",
    fill: "currentColor",
    style: {
      strokeWidth: 2.6664
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.a38c9e97.svg";
export { ForwardRef as ReactComponent };